import { createAction } from '@reduxjs/toolkit';

// PAYOUT SUMMARY ACTIONS
export const getPayoutSummaryRequest = createAction('GET_PAYOUT_SUMMARY_REQUEST', (startDate, endDate, merchantId, storeID) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			storeID
        }
    }
});

export const getPayoutSummarySuccess = createAction('GET_PAYOUT_SUMMARY_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getPayoutSummaryFailure = createAction('GET_PAYOUT_SUMMARY_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});

// PAYOUT HISTORY ACTIONS
export const getPayoutHistoryRequest = createAction('GET_PAYOUT_HISTORY_REQUEST', (startDate, endDate, merchantId, searchTerm, data) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			searchTerm,
			data
        }
    }
});

export const getPayoutHistorySuccess = createAction('GET_PAYOUT_HISTORY_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getPayoutHistoryFailure = createAction('GET_PAYOUT_HISTORY_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});

// PAYOUT BY ORDER HISTORY ACTIONS
export const getPayoutByOrderHistoryRequest = createAction('GET_PAYOUT_BY_ORDER_HISTORY_REQUEST', (startDate, endDate, merchantId, searchTerm, data) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			searchTerm, 
			data
        }
    }
});

export const getPayoutByOrderHistorySuccess = createAction('GET_PAYOUT_BY_ORDER_HISTORY_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getPayoutByOrderHistoryFailure = createAction('GET_PAYOUT_BY_ORDER_HISTORY_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});

export const getPayoutByOrderDownloadRequest = createAction('GET_PAYOUT_BY_ORDER_DOWNLOAD_REQUEST', (startDate, endDate, merchantId, searchTerm, data,selectionValue) => {
    return{
        payload: {
			startDate,
			endDate,
			merchantId,
			searchTerm, 
			data,
            selectionValue
        }
    }
});

export const getPayoutByOrderDownloadSuccess = createAction('GET_PAYOUT_BY_ORDER_DOWNLOAD_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getPayoutByOrderDownloadFailure = createAction('GET_PAYOUT_BY_ORDER_DOWNLOAD_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});